const childrenLoaded = require('@alexspirgel/children-loaded')
import { CountUp } from 'countup.js'
import tippy from 'tippy.js'

class ComponentCostCalculator extends HTMLDivElement {
  constructor() {
    super()
  }

  async connectedCallback() {
    await childrenLoaded(this)
    this.initialize()
  }

  initialize() {
    if (this.initialized) {
      return
    }
    this.initialized = true

    this.dataSetElements = this.querySelectorAll(
      '.component-cost-calculator__data .node-calculator-data-set--teaser'
    )
    this.formElement = this.querySelector('.component-cost-calculator__filters')
    this.clearButtonElement = this.querySelector(
      '.component-cost-calculator__reset'
    )

    this.dataSet = []
    for (let dataSetElement of this.dataSetElements) {
      let jsonData = JSON.parse(dataSetElement.innerHTML)
      this.dataSet = this.dataSet.concat(jsonData)
    }

    this.initializeFilters()
    this.clearResultsData()
    this.initializeTooltips()

    this.formElement.addEventListener('submit', this.formSubmitHandler)
    this.clearButtonElement.addEventListener(
      'click',
      this.clearButtonClickHandler
    )
  }

  get filterIds() {
    let dataFilters = Array.from(this.querySelectorAll('[data-filter]'))
    dataFilters = dataFilters.map(element => {
      return element.getAttribute('data-filter')
    })
    return dataFilters
  }

  getUniqueDataSetValues(dataSet, filterId) {
    return [
      ...new Set(
        dataSet.map(item => {
          return item[filterId]
        })
      )
    ]
  }

  updateFilterOptions(filterId, allowedValues) {
    // console.log('updateFilterOptions');
    // console.log('filterId:', filterId);
    // console.log('allowedValues:', allowedValues);

    const filterInput = this.querySelector(`[data-filter="${filterId}"] select`)
    let filterOptions = filterInput.querySelectorAll('option')
    const initialOptionsTemplate = this.querySelector(
      `[data-filter="${filterId}"] .component-cost-calculator__filter-initial-options`
    )

    // remove disallowed options
    let removed_selected_value = false
    if (filterId != 'academic_year') {
      // don't remove choices from the academic year filter
      for (let filterOption of filterOptions) {
        let value = filterOption.getAttribute('value')
        const duplicateValueOptionElements = filterInput.querySelectorAll(
          `option[value="${value}"]`
        )
        if (
          // normal conditions that if met will remove the item
          (duplicateValueOptionElements.length > 1 ||
            (Array.isArray(allowedValues) &&
              !allowedValues.includes(value) &&
              value != '')) &&
          // special carve-out to prevent 'Western Regional Graduate Program' from being removed
          !(
            filterId == 'residency' &&
            (!Array.isArray(allowedValues) ||
              (Array.isArray(allowedValues) &&
                allowedValues.includes('resident_data'))) &&
            value == 'resident_data_wrgp'
          )
        ) {
          if (filterInput.value == value) {
            removed_selected_value = true
          }
          filterOption.remove()
        }
      }
    }

    // make sure default option is available
    let filterDefaultOption = filterInput.querySelector('option[value=""]')
    const initialOptionsTemplateDefaultOption =
      initialOptionsTemplate.content.querySelector('option[value=""]')
    if (!filterDefaultOption) {
      filterInput.appendChild(initialOptionsTemplateDefaultOption)
    }
    if (filterDefaultOption && initialOptionsTemplateDefaultOption) {
      filterDefaultOption.textContent =
        initialOptionsTemplateDefaultOption.textContent
    }

    // add missing options
    if (Array.isArray(allowedValues)) {
      for (let allowedValue of allowedValues) {
        let option = filterInput.querySelector(
          `option[value="${allowedValue}"]`
        )
        if (!option) {
          const missingOption = initialOptionsTemplate.content
            .querySelector(`option[value="${allowedValue}"]`)
            .cloneNode(true)
          filterInput.appendChild(missingOption)
        }
      }
    }
    // special case to add Western Regional Graduate Program
    let residentDataOption = filterInput.querySelector(
      'option[value="resident_data"]'
    )
    let wrgpOption = filterInput.querySelector(
      'option[value="resident_data_wrgp"]'
    )
    if (!wrgpOption && residentDataOption) {
      const wrgpInitialOption = initialOptionsTemplate.content.querySelector(
        'option[value="resident_data_wrgp"]'
      )
      if (wrgpInitialOption) {
        filterInput.appendChild(wrgpInitialOption)
      }
    }

    // reset value if selected value was removed
    if (removed_selected_value) {
      filterInput.value = ''
    }

    // sort options by initial options order
    filterOptions = filterInput.querySelectorAll('option')
    filterDefaultOption = filterInput.querySelector('option[value=""]')
    const initialOptionElements =
      initialOptionsTemplate.content.querySelectorAll('option')
    let previousElement = filterDefaultOption
    for (let initialOptionElement of initialOptionElements) {
      const initialOptionValue = initialOptionElement.getAttribute('value')
      if (initialOptionValue != '') {
        const optionElement = filterInput.querySelector(
          `option[value="${initialOptionValue}"]`
        )
        if (optionElement) {
          filterInput.insertBefore(optionElement, previousElement.nextSibling)
          previousElement = optionElement
        }
      }
    }

    // set enabled or disabled status
    filterOptions = filterInput.querySelectorAll('option')
    if (filterOptions.length <= 1) {
      filterInput.setAttribute('disabled', '')
      if (filterOptions.length == 0) {
        filterDefaultOption = filterInput.querySelector('option[value=""]')
        if (filterDefaultOption) {
          filterDefaultOption.textContent = 'No choices available'
        }
      }
    } else {
      filterInput.removeAttribute('disabled')
    }
  }

  initializeFilters() {
    for (let filterId of this.filterIds) {
      let uniqueValues = this.getUniqueDataSetValues(this.dataSet, filterId)
      this.updateFilterOptions(filterId, uniqueValues)
      const filterSelectElement = this.querySelector(
        `select[name="${filterId}"]`
      )
      if (filterSelectElement) {
        filterSelectElement.addEventListener('change', () => {
          this.clearResultsData()
        })
      }
    }
    const academicYearFilterSelectElement = this.querySelector(
      `select[name="academic_year"]`
    )
    if (academicYearFilterSelectElement) {
      academicYearFilterSelectElement.addEventListener('change', () => {
        const filteredDataSet = this.filterData({
          academic_year: academicYearFilterSelectElement.value
        })
        let schoolCollegeUniqueValues = this.getUniqueDataSetValues(
          filteredDataSet,
          'school_college'
        )
        this.updateFilterOptions('school_college', schoolCollegeUniqueValues)
      })
    }
  }

  get formFilterValues() {
    const values = {}
    const selectElements = this.querySelectorAll('[data-filter] select')
    for (let selectElement of selectElements) {
      const name = selectElement.getAttribute('name')
      const value = selectElement.value
      if (value != '') {
        values[name] = value
      }
    }
    return values
  }

  filterData(filterValues) {
    let dataSet = this.dataSet
    for (let key in filterValues) {
      let value = filterValues[key]
      dataSet = dataSet.filter(item => {
        return item[key] == value
      })
    }
    return dataSet
  }

  formSubmitHandler = event => {
    event.preventDefault()
    const filteredData = this.filterData(this.formFilterValues)
    if (filteredData.length) {
      this.updateResultsData(filteredData[0])
      this.showHideResultsTexts('show')
      const resultsElement = this.querySelector(
        '.component-cost-calculator__results'
      )
      resultsElement.scrollIntoView({ behavior: 'smooth' })
    }
    return false
  }

  formatOutputNumber(number) {
    number = parseFloat(number)
    number = number.toFixed(2)
    number = number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // number = '$' + number;
    return number
  }

  get dataSetResultKeys() {
    return [
      'tuition',
      'im_fees',
      'food_housing',
      'loan_fees',
      'bcmse',
      'pet',
      'total'
    ]
  }

  updateResultsData(dataSet, skipCountUp = false) {
    const countUpOptions = {
      startVal: 0,
      decimalPlaces: 2,
      duration: 1,
      useGrouping: true,
      separator: ',',
      decimal: '.'
    }
    const resultsTableElement = this.querySelector(
      '.component-cost-calculator__results-table'
    )
    for (let key of this.dataSetResultKeys) {
      let termValue = parseFloat(dataSet[key])
      let yearValue = parseFloat(termValue) * 2
      const cells = resultsTableElement.querySelectorAll(
        `tr[data-id="${key}"] td`
      )
      if (cells.length == 2) {
        // term
        const termValueElement = cells[0].querySelector('.value')
        if (termValueElement) {
          if (skipCountUp) {
            termValueElement.textContent = this.formatOutputNumber(termValue)
          } else if (!termValueElement.countUp) {
            termValueElement.countUp = new CountUp(
              termValueElement,
              termValue,
              countUpOptions
            )
            termValueElement.countUp.start()
          } else {
            termValueElement.countUp.reset()
            termValueElement.countUp.update(termValue)
          }
        }
        // year
        const yearValueElement = cells[1].querySelector('.value')
        if (yearValueElement) {
          if (skipCountUp) {
            yearValueElement.textContent = this.formatOutputNumber(yearValue)
          } else if (!yearValueElement.countUp) {
            yearValueElement.countUp = new CountUp(
              yearValueElement,
              yearValue,
              countUpOptions
            )
            yearValueElement.countUp.start()
          } else {
            yearValueElement.countUp.reset()
            yearValueElement.countUp.update(yearValue)
          }
        }
      }
    }
  }

  clearResultsData() {
    const emptyResultsData = {}
    for (let key of this.dataSetResultKeys) {
      emptyResultsData[key] = '0'
    }
    this.updateResultsData(emptyResultsData, true)
    this.showHideResultsTexts('hide')
  }

  initializeTooltips() {
    const tooltipElements = this.querySelectorAll('[data-tooltip]')
    for (let tooltipElement of tooltipElements) {
      const triggerElement = tooltipElement.querySelector(
        '[data-tooltip-trigger]'
      )
      const contentElement = tooltipElement.querySelector(
        '[data-tooltip-content]'
      )
      if (triggerElement && contentElement) {
        const tooltipXClass = 'tippy-x';
        tippy(triggerElement, {
          arrow: true,
          animation: 'fade',
          content: contentElement,
          interactive: true,
          trigger: 'click',
          onShow(instance) {
            let xElement = instance.popper.querySelector(`.${tooltipXClass}`);
            if (!xElement) {
              xElement = document.createElement('button');
              xElement.classList.add(tooltipXClass);
              xElement.innerHTML = '<span>close tooltip</span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 1L1 15M1 1L15 15" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/></svg>';
              instance.popper.querySelector('.tippy-content').append(xElement);
            }
            if (xElement) {
              xElement.addEventListener('click', () => {
                instance.hide();
              });
            }
          },
          onHide(instance) {
            let xElement = instance.popper.querySelector(`.${tooltipXClass}`);
            if (xElement) {
              xElement.removeEventListener('click', () => {
                instance.hide();
              });
            }
          },
        })
      }
    }
  }

  clearButtonClickHandler = () => {
    this.clearResultsData()
    const formInputElements = this.querySelectorAll(
      '.component-cost-calculator__filter-input'
    )
    for (let formInputElement of formInputElements) {
      formInputElement.value = ''
    }
    const formElement = this.querySelector(
      '.component-cost-calculator__filters'
    )
    formElement.scrollIntoView({ behavior: 'smooth' })
    formInputElements[0].focus()
  }

  showHideResultsTexts(showHide) {
    const noResultsText = this.querySelector(
      '.component-cost-calculator__empty-state-text'
    )
    const resultsText = this.querySelector(
      '.component-cost-calculator__results-table-text'
    )
    if (showHide == 'show') {
      noResultsText.classList.remove('show')
      resultsText.classList.add('show')
      this.clearButtonElement.classList.add('show')
    } else if (showHide == 'hide') {
      noResultsText.classList.add('show')
      resultsText.classList.remove('show')
      this.clearButtonElement.classList.remove('show')
    }
  }
}

customElements.define('component-cost-calculator', ComponentCostCalculator, {
  extends: 'div'
})
